<template>
    <v-container v-if="mobileApp">
        <v-label>{{$t('mobile_app.edit')}}</v-label>
        <v-form ref="form"
                v-model="isFormValid">
            <v-container>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('mobile_app.name')"
                                  :placeholder="$t('mobile_app.name')"
                                  v-model="mobileApp.name"
                                  :rules="requiredRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('mobile_app.app_id')"
                                  :placeholder="$t('mobile_app.app_id')"
                                  v-model="mobileApp.app_id"
                                  :rules="requiredRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('mobile_app.app_type')"
                                  :placeholder="$t('mobile_app.app_type')"
                                  v-model="mobileApp.app_type"
                                  type="number"
                                  :rules="requiredRules">
                                </v-text-field>
                </v-row>
                <v-row v-if="mobileApp && showFroalaEditor">
                    <v-col style="padding:12px 0px;margin-bottom:8px">
                        {{$t('mobile_app.endmessage')}}
                        <froala
                            v-if="showEditor"
                            :config="froalaConfig"
                            v-model="mobileApp.end_message"
                        ></froala>
                    </v-col>
                </v-row>
                <v-row v-if="mobileApp && showFroalaEditor">
                    <v-col style="padding:12px 0px;margin-bottom:8px">
                        {{$t('mobile_app.endmessage') + ' TC'}}
                        <froala
                            v-if="showEditor"
                            :config="froalaConfig"
                            v-model="mobileApp.end_message_tc"
                        ></froala>
                    </v-col>
                </v-row>
                <v-row v-if="mobileApp && showFroalaEditor">
                    <v-col style="padding:12px 0px;margin-bottom:8px">
                        {{$t('mobile_app.endmessage') + ' SC'}}
                        <froala
                            v-if="showEditor"
                            :config="froalaConfig"
                            v-model="mobileApp.end_message_sc"
                        ></froala>
                    </v-col>
                </v-row>
                <v-row>
                    <v-select outlined
                              clearable
                              :label="$t('mobile_app.company')"
                              :placeholder="$t('mobile_app.company')"
                              :items="companyOptions"
                              v-model="mobileApp.companyId"
                              :rules="requiredRules"></v-select>
                </v-row>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('mobile_app.force_update_ios_version')"
                                  :placeholder="$t('mobile_app.force_update_ios_version')"
                                  v-model="mobileApp.force_update_ios_version"
                                  :rules="requiredRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('mobile_app.force_update_ios_link')"
                                  :placeholder="$t('mobile_app.force_update_ios_link')"
                                  v-model="mobileApp.force_update_ios_link"
                                  :rules="requiredRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('mobile_app.force_update_android_version')"
                                  :placeholder="$t('mobile_app.force_update_android_version')"
                                  v-model="mobileApp.force_update_android_version"
                                  :rules="requiredRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('mobile_app.force_update_android_link')"
                                  :placeholder="$t('mobile_app.force_update_android_link')"
                                  v-model="mobileApp.force_update_android_link"
                                  :rules="requiredRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-file-input accept="image/*"
                                  :label="$t('mobile_app.banner') + ' ' + $t('mobile_app.recommendedBannerSize')"
                                  v-model="mobileApp.banner">
                        <template v-slot:selection="{file}">
                            <v-img :src="getFileUrl(file)"
                                    max-width="250px"
                                    max-height="250px"></v-img>
                        </template>
                    </v-file-input>
                </v-row>
                <v-row>
                    <v-col style="padding:12px 0px;margin-bottom:8px;z-index:1">
                        {{$t('mobile_app.forgot_password')}}
                        <froala
                            v-if="showEditor"
                            :config="froalaConfig"
                            v-model="mobileApp.forgot_password_message"
                        ></froala>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col style="padding:12px 0px;margin-bottom:8px;z-index:1">
                        {{$t('mobile_app.forgot_password') + ' TC'}}
                        <froala
                            v-if="showEditor"
                            :config="froalaConfig"
                            v-model="mobileApp.forgot_password_message_tc"
                        ></froala>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col style="padding:12px 0px;margin-bottom:8px;z-index:1">
                        {{$t('mobile_app.forgot_password') + ' SC'}}
                        <froala
                            v-if="showEditor"
                            :config="froalaConfig"
                            v-model="mobileApp.forgot_password_message_sc"
                        ></froala>
                    </v-col>
                </v-row>
                <v-label>Select Events</v-label>
                <v-data-table :headers="eventHeaders"
                              :items="events"
                              :loading="isEventPending"
                              show-select
                              @item-selected="onEventSelectedOnList"
                              v-model="selectedEvents">
                    <template v-slot:item.start_date="{value}">
                        {{DateTime.fromISO(value).toFormat('yyyy-MM-dd')}}
                    </template>
                    <template v-slot:item.end_date="{value}">
                        {{DateTime.fromISO(value).toFormat('yyyy-MM-dd')}}
                    </template>
                    <template v-slot:item.actions="{item}">
                        <v-btn color="primary"
                               @click="$router.push({name: 'event-edit', params: {eventId:item.id}})">
                            {{$t('edit')}}
                            <v-icon right>mdi-account-edit</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
                <v-label>Event Sequence</v-label>
                <v-data-table
                    :headers="selectedEventHeaders"
                    :items="selectedEvents"
                    hide-default-footer
                    :items-per-page="selectedEvents.length"
                    :loading="isEventPending"
                    >
                    <template v-slot:item.scroller="{value}">
                        <div class="handle"><v-btn icon ><v-icon>drag_handle{{value}}</v-icon></v-btn></div>
                    </template>
                    <template v-slot:item.apps_events="{value}">
                        {{value.order}}
                    </template>
                </v-data-table>
                <v-row>
                    <v-col>
                        <v-btn color="primary" @click="saveMobileApp" :disabled="!isFormValid">
                            {{$t('save')}}
                        </v-btn>
                    </v-col>
                    <v-col>
                        <v-btn color="red" dark @click="deleteMobileApp">
                            {{$t('delete')}}
                        </v-btn>
                    </v-col>
                </v-row>

            </v-container>
        </v-form>
    </v-container>
</template>

<script>
    import {computed, ref, watch,onUpdated} from '@vue/composition-api'
    import {useFind, useGet} from "feathers-vuex";
    import {DateTime} from "luxon";
    import _ from 'lodash';
    import Sortable from "sortablejs"
    import froalaConfig from "../../froala-config";

    export default {
        name: 'MobileAppEdit',
        setup(props, {root}) {
            const showEditor = ref(false);
            const {MobileApp, Company, Event, AppEvent} = root.$FeathersVuex.api;

            const mobileAppId = computed(() => root.$route.params.mobileAppId);
            const {item: mobileApp} = useGet({model: MobileApp, id: mobileAppId});

            const companyParams = computed(() => {
                return {
                    query: {
                        $sort: {
                            name: 1,
                        }
                    }
                }
            });
            const companyData = useFind({model: Company, params: companyParams});
            const companyOptions = computed(() => {
                return companyData.items.value.map(c => {
                    return {text: c.name, value: c.id}
                });
            });

            // Events
            const companyId = computed(() => {
                return mobileApp.value ? mobileApp.value.companyId : null;
            });
            const eventParams = computed(() => {
                return {
                    query: {
                        companyId: companyId.value,
                        $sort: {
                            createdAt: -1,
                        }
                    }
                }
            });
            const eventQueryWhen = computed(() => {
                return !!companyId.value;
            });
            const {items: events, isPending: isEventPending} = useFind({model: Event, params: eventParams, queryWhen: eventQueryWhen});

            const eventHeaders = ref([
                {text: root.$t('event.name'), value: 'name'},
                {text: root.$t('event.start_date'), value: 'start_date'},
                {text: root.$t('event.end_date'), value: 'end_date'},
            ]);

            const selectedEventHeaders = ref([
                {text:'',value:'scroller'},
                {text: root.$t('event.order'), value: 'apps_events'},
                {text: root.$t('event.name'), value: 'name'},
                {text: root.$t('event.start_date'), value: 'start_date'},
                {text: root.$t('event.end_date'), value: 'end_date'},
            ]);

            const originalSelectedEvents = ref([]);
            const selectedEvents = ref([]);

            const itemSelectedOnList = ref(false)
            const itemAdded = ref(false)
            const quickSortSelectedEvents = function(events){
                if(events.length<2){
                    return events
                }
                const chosenIndex = events.length - 1
                const chosen = events[chosenIndex]
                const a = []
                const b = []
                for(let i=0;i<chosenIndex;i++){
                    const temp = events[i].apps_events.order
                    temp < chosen.apps_events.order ? a.push(events[i]) : b.push(events[i])
                }

                const output = [...quickSortSelectedEvents(a),chosen,...quickSortSelectedEvents(b)]
                return output
            }
            watch(() => mobileApp.value, (newVal, oldVal) => {
                if (!oldVal && newVal) {
                    originalSelectedEvents.value = newVal.events;
                    selectedEvents.value = quickSortSelectedEvents(Array.from((newVal.events)));
                }
            });
            watch(() => companyId.value, (newVal, oldVal) => {
                if (oldVal && newVal) {
                    selectedEvents.value = [];
                }
            });

            watch(()=> selectedEvents.value,(newVal,oldVal)=>{
                if(itemSelectedOnList.value){
                    if(itemAdded.value){
                        const length = selectedEvents.value.length
                        const e = selectedEvents.value[length-1]
                        for(let i=0;i<length;i++){
                            if(i==length-1){
                                selectedEvents.value[length-1].apps_events = new AppEvent({mobileAppId: mobileAppId.value, eventId: e.id,order:length})
                            }else{
                                selectedEvents.value[i].apps_events.order = i+1
                            }
                        }
                    }else{
                        resortOrderIfRemoved();
                    }
                }
                itemSelectedOnList.value = false
            })
            const removedEvents = computed(() => {
                if (!originalSelectedEvents.value || !selectedEvents.value) {
                    return [];
                }
                return _.differenceWith(originalSelectedEvents.value, selectedEvents.value, (a, b) => {
                    return a.id === b.id;
                });
            });
            const removedAppEventParams = computed(() => {
                return {
                    query: {
                        mobileAppId: mobileAppId.value,
                        eventId: {
                            $in: removedEvents.value.map(e => e.id),
                        },
                    }
                }
            });

            const resortOrderIfRemoved = function(){
                for(let i=0;i<selectedEvents.value.length;i++){
                    selectedEvents.value[i].apps_events.order = i+1
                }
            }
            const {items: removedAppEvents, isRemovedAppEventsPending} = useFind({model: AppEvent, params: removedAppEventParams});

            const requiredRules = ref([
                value => !!value || 'Required',
            ]);
            const isFormValid = ref(false);

            const saveMobileApp = async () => {
                try {
                    let addedEvents = _.differenceWith(selectedEvents.value, originalSelectedEvents.value);
                    let reorderedEvents = Array.from(selectedEvents.value);
                    
                    if(removedAppEvents.value.length>0){
                        resortOrderIfRemoved()
                    }
                    if( mobileApp.value.banner instanceof File){
                        mobileApp.value.banner = {src:await root.$uploadFile(mobileApp.value.banner)};
                    }
                    if (!mobileApp.value.banner) {
                        mobileApp.value.banner = null;
                    }
                    
                    // Save MobileApp
                    mobileApp.value.save().then(()=>{
                        Promise.allSettled([
                            // Remove AppEvent
                            ...removedAppEvents.value.map(e => {
                                return e.remove()
                            }),
                            // Create AppEvent
                            ...addedEvents.map(e => {
                                return new AppEvent({mobileAppId: mobileAppId.value, eventId: e.id, order: e.apps_events.order}).save()
                            }),
                            ...reorderedEvents.map(e=>{
                                const appeventId = e.apps_events.id
                                const appEventId2 = e.apps_events._id

                                return new AppEvent({
                                    id: (appeventId==null)?appEventId2:appeventId,
                                    order: e.apps_events.order
                                }).patch()          
                            })

                        ]).then(() => {
                            MobileApp.get(mobileAppId.value);
                            root.$store.dispatch('showSnackBar', root.$t('mobile_app.save_successful'));

                            // root.$router.replace({name: 'mobile-app-list'});
                        }, root.$handleFeatherError.bind(root));

                    }, root.$handleFeatherError.bind(root));
                } catch (e) {
                    root.$handleFeatherError(e);
                }
            };

            const onEventSelectedOnList = function(item){
                itemSelectedOnList.value = true
                itemAdded.value = item.value
            }
            const deleteMobileApp = () => {
                if (confirm(root.$t('mobile_app.confirm_delete'))) {
                    mobileApp.value.remove().then(() => {
                        root.$router.replace({name: 'mobile-app-list'});
                    }, root.$handleFeatherError.bind(root));
                }
            };
            
            
            onUpdated(() => {
                let table = document.querySelectorAll('.v-data-table tbody')[1];
                Sortable.create(table,
                    {
                        handle:".handle", // Look for class with name "handle"
                        onEnd({newIndex,oldIndex}){
                            const rowSelected = selectedEvents.value.splice(oldIndex,1)[0];
                            selectedEvents.value.splice(newIndex,0,rowSelected);
                            if(newIndex>oldIndex){ // Moving Down the Table
                                for(let i=oldIndex;i<=newIndex;i++){
                                    if(i!==newIndex){
                                        selectedEvents.value[i].apps_events.order -= 1
                                    }else{
                                        selectedEvents.value[i].apps_events.order = newIndex + 1
                                    }
                                }
                            }else if(newIndex<oldIndex){ // Moving Up the Table
                                for(let i=oldIndex;i>=newIndex;i--){
                                    if(i!==newIndex){
                                        selectedEvents.value[i].apps_events.order += 1
                                    }else{
                                        selectedEvents.value[i].apps_events.order = newIndex + 1
                                    }
                                }
                            }
                        }
                    }
                )
            });

            const showFroalaEditor = computed(() => {
                // Convert app_type to number since v-model with type="number" still returns string
                return showEditor.value && mobileApp.value && Number(mobileApp.value.app_type) === 100;
            });
            
            return {
                mobileApp,
                companyOptions,

                events,
                isEventPending,
                eventHeaders,
                selectedEventHeaders,
                selectedEvents,
                eventQueryWhen,

                requiredRules,
                isFormValid,
                saveMobileApp,
                deleteMobileApp,

                DateTime,

                removedAppEventParams,
                removedAppEvents,
                getFileUrl: root.$getFileURL,
                onEventSelectedOnList,

                showEditor,
                froalaConfig: {
                    ...froalaConfig,
                    toolbarSticky: false,
                    zIndex: 2000
                },
                showFroalaEditor

            }
        },
        mounted() {
            setTimeout(() => {
               this.showEditor = true;
            }, 100);
        }
    }
</script>